
import RcDomainObject from "@/domain/common/RcDomainObject";

export default class Category extends RcDomainObject {
  
  static MODEL_NAME = 'VehicleCategory';
  
  static FIELDS = {
    NAME : 'name',
  }
  
  static VALUES = {
    TRAILER: 'trailer',
    TRUCK: 'pickup',
    BUS: 'bus',
    LIMO: 'Limo',
    CAR: 'car',
    VAN: 'van',
    CUBE_BAN: 'Cube Van',
    SCHOOL_BUS: 'schoolbus',
    COACH: 'coach',
    SUV: 'suv',
    TOW: 'tow',
  }
  
  constructor(domain, data) {
    super(domain, data, Category.MODEL_NAME);
  }

  fields() {
    return Category.FIELDS;
  }
  
  find() {
    return this.domain.categorys().findById(this.id());
  }
  
  name() {
    return this.getString(Category.FIELDS.NAME);
  }
  
  isTrailer() {
    return this.name().toLowerCase() === Category.VALUES.TRAILER || 
        this.id() === "#23:5"; 
  }
  
  isEquipment() {
    return this.name().toLowerCase() === Category.VALUES.TRAILER || 
        this.id() === "#23:22"; 
  }

  isBus() {
    var id = this.id();
    var name = this.name().toLowerCase();
    return name === Category.VALUES.BUS || 
        id === "#23:6" ||
        id === "#23:15" ||
        id === "#23:20" ||
        id === "#23:23";
  }

  isLimo() {
    var id = this.id();
    var name = this.name().toLowerCase();
    return name === Category.VALUES.LIMO || 
        id === "#23:15";
  }
  
  isCar() {
    var id = this.id();
    var name = this.name().toLowerCase();
    return name === Category.VALUES.CAR || 
        id === "#23:0";
  }

  isSuv() {
    var id = this.id();
    var name = this.name().toLowerCase();
    return name === Category.VALUES.SUV || 
        id === "#23:2";
  }

  isTow() {
    var id = this.id();
    var name = this.name().toLowerCase();
    return name === Category.VALUES.TOW || 
        id === "#23:4";
  }

  isVan() {
    var id = this.id();
    var name = this.name().toLowerCase();
    return name === Category.VALUES.VAN || 
        id === "#23:10";
  }

  isTruck() {
    return !this.isTrailer() && !this.isBus();
  }
  
  isVehicle() {
    return this.isTruck() || this.isBus();
  }
  
  copy() {
    var data = this._copy();
    return new Category(this.domain, data);
  }
}